<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-4" v-if="!optedOut">
          <img src="@/assets/img/optout.svg?data" class="optout" alt="No opt-out access" />
          <div v-html="data.optout.noAccessOptoutText"></div>
        </div>
        <div class="col-md-4" v-if="optedOut">
          <img src="@/assets/img/check-square.svg?data" class="checksquare" alt="Checkmark indicator" />
          <div v-html="data.optout.resetConsentText"></div>
          <div v-html="data.optout.optoutDisclaimer"></div>
        </div>
        <!-- <div class="col-md-4" v-if="!optedOut && grantAccess">
          <img src="@/assets/img/optout.svg?data" class="optout" alt="User being opted out" />
          <div v-html="data.optout.optoutConfirmText"></div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-block" @click="optOut()" v-html="data.optout.optoutBtn"></button>
          <Survey class="d-flex justify-content-center m-top-5" questionId="132813328" />
        </div> -->
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
// import Survey from '../../src/components/Survey'
import { request } from '../plugins/datocms'
import { parseJwt } from '../plugins/jwtparser'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'optout',
  components: {
    // Survey
  },
  data () {
    return {
      data: null,
      optedOut: false
    }
  },
  methods: {
    optOut () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      axios._post(config.optOutUri).then(response => {
        if (response) {
          this.logOutUser()
          loader.hide()
        }
      }, (error) => {
        if (error.response) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        }
      })
    },
    logOutUser () {
      this.$store.commit('setLogin', false)
      this.$store.commit('setName', null)
      var cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      var access = localStorage.getItem('access')
      localStorage.clear()
      sessionStorage.clear()
      if (cookies) localStorage.setItem('vue-cookie-accept-decline-cookies', cookies)
      if (access) localStorage.setItem('access', access)
      window.location.href = window.location.origin.concat('/')
    }
  },
  async beforeMount () {
    if (sessionStorage.getItem('jwt')) {
      const decodedJwt = parseJwt(sessionStorage.getItem('jwt'))
      if (decodedJwt.consent === 'OptOut') {
        this.optedOut = true
      }
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          optout(locale: ` + sessionStorage.getItem('language') + `) {
            optoutConfirmText
            optoutBtn
            optoutDisclaimer
            resetConsentText
            noAccessOptoutText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button:disabled {
  opacity: 0.3;
}
.optout {
  width: 60px;
  height: 60px;
  margin-bottom: 5vh;
}
.checksquare {
  width: 80px;
  height: 80px;
  margin-bottom: 4vh;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OptOut.vue